<script>
import sortBy from "lodash/sortBy";
export default {
  components: {
    PrexcTemplate: () =>
      import(
        /* webpackPrefetch: true */ "@/components/tables/finance-template-prexcs.vue"
      ),
    DeliveryUnitTemplate: () =>
      import(
        /* webpackPrefetch: true */ "@/components/tables/template-deliveryUnit.vue"
      ),
  },
  props: {
    outcomes: {},
    template: null,
  },
  data() {
    return {
      prexcs: [],
      tableBusy: false,
      lastId: 0,
      templateDeliveryUnits: [],
      start: 0,
      fields: [
        {
          key: "action",
          label: "Details",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "outcomeName",
          label: "Outcome",
        },
      ],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      filter: null,
      filterOn: [],
      prexcTableBusy: false,
    };
  },
  methods: {
    printLIB(data) {
      this.$emit("lib", data);
    },
    printOPCR(data) {
      this.$emit("opcr", data);
    },
    printPPMP(data) {
      this.$emit("ppmp", data);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showDtls(record) {
      record.toggleDetails();
      record.item.rotateChevy = !record.item.rotateChevy;
      if (this.lastId === 0 || this.lastId === record.id) {
        this.lastId = record.id;
      } else {
        this.outcomes.find((x) => x.id === this.lastId).rotateChevy = false;
        this.outcomes.find((x) => x.id === this.lastId).showDtls = false;
        this.lastId = record.id;
      }

      if (record.item.rotateChevy) {
        this.prexcTableBusy = true;
        setTimeout(() => {
          this.getPrexcs(record.item);
        }, 500);
      }
    },
    getPrexcs(record) {
      this.$store
        .dispatch("financeTemplate/getAllPrexcListing", {
          financeTemplateId: this.template,
          outcomeId: record.id,
        })
        .then((response) => {
          let sample = response.data.map((item) => ({
            ...item,
            expenditures: [],
            showDetails: false,
            rotateChevy: false,
          }));
          // this.prexcs = sortBy(sample, "prexcName");
          this.outcomes.find((item) => item.id === record.id).prexcs = sortBy(
            sample,
            "prexcName"
          );
          // this.prexcs = sortBy(JSON.parse(JSON.stringify(this.prexcs)), "prexcName");
          this.prexcTableBusy = false;
        })
        .catch(() => {
          this.prexcTableBusy = false;
          this.showToast("Error getting prexc listing", "error");
        });
    },
    updatePrexc(record) {
      this.$store
        .dispatch("financeTemplate/getPrexcTemplateBalance", {
          financeTemplateId: this.template,
          prexcId: record.prexc,
        })
        .then((response) => {
          this.outcomes
            .find((outcome) => outcome.id === record.outcome)
            .prexcs.find((item) => item.id === record.prexc).balance =
            response.data;
          // this.prexcs.find((item) => item.id === record.prexc).balance = response.data;
          this.$emit("updateTemplate", this.template);
        })
        .catch(() => {
          this.showToast("Error getting prexc balance", "error");
        });
    },
    loadDeliveryUnits() {
      //   if (this.templateDeliveryUnits.length === 0) {
      this.$store.commit("financeTemplate/setIsDeliveryUnitsLoading", true);
      this.$store
        .dispatch(
          "financeTemplate/getAllDeliveryUnitsByTemplate",
          this.template
        )
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.error, "error");
            return;
          }
          this.templateDeliveryUnits = response.data.map((item) => ({
            ...item,
            officeBudget: [],
            showDetails: false,
            isLoadingDetails: false,
          }));
          this.$store.commit(
            "financeTemplate/setIsDeliveryUnitsLoading",
            false
          );
        });
      //   }
    },
    updateDeliveryUnit(id) {
      this.$store
        .dispatch("financeTemplate/getDeliveryUnitFigures", {
          financeTemplateId: this.template,
          deliveryUnitId: id,
        })
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.error, "error");
            return;
          }
          this.templateDeliveryUnits.find((x) => x.id === id).totalAllocated =
            response.data.amount;
          this.templateDeliveryUnits.find((x) => x.id === id).totalUsed =
            response.data.totalUsed;
          this.templateDeliveryUnits.find((x) => x.id === id).remaining =
            response.data.balance;
        })
        .catch((error) => {
          console.log(error);
          this.showToast("Error fetching delivery unit figures", "error");
        });

      this.$emit("updateTemplate", this.template);
    },
    resetChevy() {
      this.outcomes.forEach((item) => {
        item.rotateChevy = false;
      });
    },
    startToZero() {
      this.start = 0;
    },
    updateTemplate(id) {
      this.$emit("updateTemplate", id);
    },
  },
};
</script>
<template>
  <b-tabs class="mt-3" v-model="start">
    <b-tab lazy @click="resetChevy">
      <template #title>
        <i class="bx bx-doughnut-chart me-3 align-middle"></i>Object Of
        Expenditures
      </template>
      <div class="table-responsive">
        <b-table
          class="table project-list-table table-nowrap align-middle table-borderless"
          :items="outcomes"
          :fields="fields"
          :per-page="perPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          :busy="tableBusy"
          @filtered="onFiltered"
          show-empty
        >
          <template #empty="scope">
            <div class="text-center">
              <h5 class="text-secondary">{{ scope.emptyText }}</h5>
            </div>
          </template>
          <template #table-busy>
            <div class="d-flex justify-content-center align-items-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-20px h-20px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(action)="row">
            <a href="javascript:void(0)" role="button" @click="showDtls(row)">
              <!-- <i
                      :class="{
                        'mdi mdi-eye-outline text-info': !row.item.rotateChevy,
                        'mdi mdi-eye-off-outline text-danger': row.item.rotateChevy,
                      }"
                    ></i> -->
              <i
                class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                :class="{
                  'rotate-90': row.item.rotateChevy,
                }"
              ></i>
            </a>
          </template>
          <template #row-details="row">
            <div
              v-if="prexcTableBusy"
              class="my-3 d-flex align-items-center justify-content-center"
            >
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
            <div class="pt-4 m-0" v-else>
              <PrexcTemplate
                :prexcs="row.item.prexcs"
                :outcome="row.item.id"
                :tableBusy="tableBusy"
                :template="template"
                @updatePrexc="updatePrexc"
              />
            </div>
          </template>
        </b-table>
      </div>
    </b-tab>
    <b-tab lazy @click="loadDeliveryUnits">
      <template #title>
        <i class="bx bx-buildings me-3 align-middle"></i>Delivery Units
      </template>
      <div
        class="d-flex justify-content-center align-items-center"
        v-if="$store.state.financeTemplate.isDeliveryUnitsLoading"
      >
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-20px h-20px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <strong>Loading...</strong>
      </div>
      <DeliveryUnitTemplate
        v-else
        :deliveryUnits="templateDeliveryUnits"
        :template="template"
        @update="updateDeliveryUnit"
        @updateTemplate="updateTemplate"
        @lib="printLIB"
        @opcr="printOPCR"
        @ppmp="printPPMP"
        class="mt-3"
      />
    </b-tab>
  </b-tabs>
</template>
